var common = require("./common.js")

module.exports = {
    idtoken:{
        qrcode:function(){
            return common.fetch("/auth/idtoken/qrcodeValue", {
                type: "GET"
            }).data
        },
        validate:function(ticket){
            return common.fetch("/auth/qr/login/validate", {
                type: "GET",
                query: {ticket: ticket}
            }).data;
        }
    },
    idShield: {
        deviceList: function () {
            return common.fetch("/auth/device/list", {
                type: "GET"
            }).data;
        },
        enable: function (query) {
            common.fetch("/auth/device/enable", {
                type: "POST",
                query: query
            })
        },
        unbind: function (id) {
            common.fetch("/auth/device/unbinding", {
                type: "POST",
                query: {id: id}
            })
        }
    },
    auth:{
        list:function(accountName,appCode){
            return common.fetch("/auth/delegation/delegationList", {
                type: "GET",
                query: {accountName:accountName,appCode:appCode}
            }).data;
        },
        userSearch:function(param){
            return common.fetch("/auth/personSubject/listPersonSubject", {
                type: "POST",
                data: JSON.stringify({code:param.condName,pageSize:20})
            }).data;
        },
        remove:function(param){
            return common.fetch("/auth/delegation/delete", {
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        }
    },
    editAttr:{
        info:function(param){
            return common.fetch("/auth/account/accountInfo", {
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        },
        update:function(param){
            return common.fetch("/auth/account/updateExtraProp", {
                type: "POST",
                data: JSON.stringify(param)
            });
        }
    },
    logs: {
        loginLog:function (param) {
            return common.fetch('/auth/audit/loginLog',{
                type: "POST",
                data: JSON.stringify(param)
            });
        }
    },
    user:{
        getUser:function(){
            return common.fetch("/auth/getUser", {
                type: "GET",
                query: {}
            }).data;
        },
        userInfo:function(){
            return common.fetch("/auth/user/userInfo", {
                type: "POST",
            });
        },
        allUnmodifiableAttribute:function(){
            return common.fetch("/auth/sysconfig/allUnmodifiableAttribute", {
                type: "GET",
                query: {}
            }).data;
        },
        update:function(param){
            return common.fetch('/auth/user/updateExtraProp',{
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        }
    },
    workflow:{
        listApp:function(){
            return common.fetch("/auth/workflow/listApp", {
                type: "GET",
                query: {}
            }).data;
        },
        //已审批
        getMyRatifyFinishedWorkflow:function(param){
            return common.fetch("/auth/workflow/getMyRatifyFinishedWorkflow", {
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        },
        //由我发起
        getMySubmitWorkflow:function(param){
            return common.fetch("/auth/workflow/getMySubmitWorkflow", {
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        },
        //已完成
        getMySubmitWorkflowAndFinished:function(param){
            return common.fetch("/auth/workflow/getMySubmitWorkflowAndFinished", {
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        },
        //待审批
        getNeedMyRatifyWorkflow:function(param){
            return common.fetch("/auth/workflow/getNeedMyRatifyWorkflow", {
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        },
        //批量审批
        completeBatch:function(param){
            return common.fetch("/auth/workflow/completeBatch", {
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        },
        history:function(processInstanceId){
            return common.fetch("/auth/workflow/history", {
                type: "GET",
                query: {processInstanceId:processInstanceId}
            }).data;
        },
        create:function(param){
            return common.fetch("/auth/workflow/create", {
                type: "POST",
                data: JSON.stringify(param)
            });
        },
        complete:function(param){
            return common.fetch("/auth/workflow/complete", {
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        },
        cancel:function(processId){
            return common.fetch("/auth/workflow/cancel", {
                type: "POST",
                query: {processId:processId}
            }).data;
        },
        startForm:function(appLabel){
            return common.fetch("/auth/workflow/startForm", {
                type: "GET",
                query: {appLabel:appLabel}
            }).data;
        },
        showFormData:function(processInstanceId){
            return common.fetch("/auth/workflow/showFormData", {
                type: "GET",
                query: {processInstanceId:processInstanceId}
            }).data;
        },
        getAccountInfos:function(accountApplyParamId){
            return common.fetch("/auth/workflow/getAccountInfos", {
                type: "GET",
                query: {accountApplyParamId:accountApplyParamId?accountApplyParamId:null}
            }).data;
        },
        processInfo:function(processInstanceId){
            return common.fetch("/auth/workflow/processInfo", {
                type: "GET",
                query: {processInstanceId:processInstanceId}
            }).data;
        },
        getAppMetaPropertys:function(appId){
            return common.fetch("/auth/workflow/getAppMetaPropertys", {
                type: "GET",
                query: {appId:appId}
            }).data;
        },
        batchApplyAccountList:function(appId,processInstanceId,accountApplyParamId){
            return common.fetch("/auth/workflow/batchApplyAccountList", {
                type: "GET",
                query: {appId:appId,processInstanceId:processInstanceId,accountApplyParamId:accountApplyParamId}
            }).data;
        },
        //用户组织机构
        getMetaPropertys:function(namespaceEnum){
            return common.fetch("/auth/workflow/getMetaPropertys", {
                type: "GET",
                query: {namespaceEnum:namespaceEnum}
            }).data;
        },
        batchApplyUserList:function(accountApplyParamId){
            return common.fetch("/auth/workflow/batchApplyUserList", {
                type: "GET",
                query: {accountApplyParamId:accountApplyParamId}
            }).data;
        },
        batchApplyOrganizationList:function(accountApplyParamId){
            return common.fetch("/auth/workflow/batchApplyOrganizationList", {
                type: "GET",
                query: {accountApplyParamId:accountApplyParamId}
            }).data;
        },
        getApplyParamInfos:function(accountApplyParamId,processInstanceId){
            return common.fetch("/auth/workflow/getApplyParamInfos", {
                type: "GET",
                query: {accountApplyParamId:accountApplyParamId?accountApplyParamId:null,processInstanceId:processInstanceId}
            }).data;
        },
        
    },
    config:{
        findAll:function(param){
            return common.fetch("/auth/systemnotice/find", {
                type: "POST",
                data: JSON.stringify(param)
            }).data;
        },
        findUserUnreadNotice:function(){
            return common.fetch("/auth/systemnoticeuserread/findUserUnreadNotice", {
                type: "GET",
                query: {}
            }).data;
        },
        userRead:function(noticeId){
            return common.fetch("/auth/systemnoticeuserread/add", {
                type: "POST",
                query: {noticeId:noticeId}
            }).data;
        },
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/utiles/service.js
// module id = 3
// module chunks = 0